import { IconName } from '@ardoq/icons';
import { ViewOptionsHeader } from './ViewOptionsHeader';
import { FlexBox } from '@ardoq/layout';
import { NewBadge } from '@ardoq/status-ui';
import { ViewOptionsClickableIcon } from '@ardoq/perspectives-sidebar';
import { TooltipTemplate } from '@ardoq/tooltip';
import { t, type I18nLocale } from '@ardoq/i18n';

type SubLevelPageHeaderProps = {
  title: string;
  knowledgeBaseLink?: string;
  shareFeedbackUrl?: string;
  isNew?: boolean;
  onBackButtonClick: VoidFunction;
  onCloseClick: VoidFunction;
  i18nLocale: I18nLocale;
};

const SubLevelPageHeader = ({
  title,
  knowledgeBaseLink,
  shareFeedbackUrl,
  isNew,
  onBackButtonClick,
  onCloseClick,
  i18nLocale,
}: SubLevelPageHeaderProps) => (
  <ViewOptionsHeader
    isUnderlined
    onCloseClick={onCloseClick}
    closeLabel={t(
      i18nLocale,
      'appLayout:closeViewSettings',
      'Close view settings'
    )}
  >
    <FlexBox gap="small" align="center">
      <ViewOptionsClickableIcon
        iconName={IconName.CHEVRON_LEFT}
        label={t(
          i18nLocale,
          'appLayout:backToViewSettings',
          'Back to view settings'
        )}
        onClick={onBackButtonClick}
      />
      {title}
      {knowledgeBaseLink && (
        <ViewOptionsClickableIcon
          iconName={IconName.HELP}
          label={t(i18nLocale, 'appLayout:knowledgeBase', 'Knowledge base')}
          onClick={e => {
            e.stopPropagation();
            window.open(knowledgeBaseLink, '_blank noreferrer');
          }}
        />
      )}
      {shareFeedbackUrl && (
        <ViewOptionsClickableIcon
          iconName={IconName.INFO}
          label={t(i18nLocale, 'appLayout:shareFeedback', 'Share feedback')}
          data-tooltip-template={TooltipTemplate.WITH_OPEN_IN_NEW_ICON_SMALL}
          onClick={e => {
            e.stopPropagation();
            window.open(shareFeedbackUrl, '_blank noreferrer');
          }}
        />
      )}
      {isNew && <NewBadge i18nLocale={i18nLocale} />}
    </FlexBox>
  </ViewOptionsHeader>
);

export { SubLevelPageHeader };
